import React from "react";
import Breadcrumbs from "../../assets/Components/breadcrumbs/breadcrumbs";
import s from './error404.module.css';
import useDocumentTitle from "../../assets/Tools/DocumentTitle/DocumentTitle";

const Error404 = () => {

    useDocumentTitle('Страница не найдена');

    return (
        <div className={s.error}>
            <div className={`${s.errorContent} content`}>
                <h3>404</h3>
                <p>Добро пожаловать на страницу 404!<br/>
                    Возможно, запрашиваемая Вами страница была перенесена или удалена.<br/>
                    Пожалуйста, воспользуйтесь навигацией или формой поиска, чтобы найти интересующую Вас
                    информацию.<br/>
                </p>
            </div>
        </div>
    )
}


export default Error404;